import { types } from 'mobx-state-tree';
import { api } from 'src/api';
import { createAsync } from 'src/utils/asyncModel';
const getAllAmenitiesRawAsync = createAsync(() => {
  return async function getAllAmenities(options) {
    const resp = await api.Amenities.getAllAmenities(options);
    return resp;
  };
});
const getAllCommonAreaAmenitiesRawAsync = createAsync(() => {
  return async function getAllCommonAreaAmenities(options) {
    const resp = await api.Amenities.getAllCommonAreaAmenities(options);
    return resp;
  };
});
const AmenitiesStore = types.model('AmenitiesStore', {
  getAllAmenitiesRawAsync,
  getAllCommonAreaAmenitiesRawAsync
});
export const amenities = types.optional(AmenitiesStore, {});